import { Entity, Field } from "typegraph";

@Entity({one: "subscription", many: "subscriptionsUser"})
export default class Subscription {

	@Field()
	public id: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/entities/Subscription.ts